<template>
  <div class="l-main">
    <div class="c-language-bar">
      <span class="c-language-bar__label">Language</span>
      <app-tabs
        variant="pills"
        label="Language"
        :tabs="languageTabs"
        :value="currentLanguage.code"
        @input="changeLanguageByCode"
      />
    </div>

    <div class="l-main__ctn">
      <div class="c-table-wrapper l-seo-rules__templates-table">
        <base-table-component
          :prop-data="seoRulesTableData"
          empty-title="No SEO templates"
          empty-description="There are no templates for this language yet."
        >
          <template v-slot:default="slotProps">
            <span class="c-table__btn-wrap">
              <generic-button
                icon
                transparent
                text-inherit
                @click="editSeoRule(slotProps.selected.seoRule)"
              >
                <md-tooltip md-direction="top">
                  Edit SEO rule
                </md-tooltip>
                <img src="../../../../../assets/edit-button.svg" alt="">
              </generic-button>
            </span>
          </template>
        </base-table-component>
      </div>
    </div>
  </div>
</template>

<script>
import GenericButton from '../../../../../shared/buttons/GenericButton';
import AppTabs from '@/shared/app-tabs/AppTabs';
import BaseTableComponent from '@/shared/table/BaseTableComponent'
import EditSeoRuleModal from '../content-edit/edit'
import { capitalize, get } from 'lodash'
import { jsonParse } from '@/helpers/transformers'
import { seoRulesService } from '@/services/seo-rules'
import { languageService } from '@/services/language'

export default {
  name: "Templates",

  components: {
    GenericButton,
    BaseTableComponent,
    AppTabs,
  },

  props: {
    website: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      seoTemplates: [],
      fetchedResults: false,
      languages: [],
      currentLanguage: {},
      defaultLanguageId: null,
    };
  },

  computed: {
    languageTabs() {
      return this.languages.map(language => ({ key: language.code, label: String(language.code).toUpperCase() }));
    },

    seoRulesTableData() {
      if (!this.seoTemplates) {
        return [];
      }

      return this.seoTemplates.map(seoRule => ({
        seoRule: seoRule,
        rowData: {
          name: capitalize(seoRule.translation.replace('-', ' ')),
          'Page Title - H1': seoRule.pageTitle,
          'Meta Title': seoRule.metaTitle,
          'Meta Description': seoRule.metaDescription
        }
      }));
    },
  },

  async created() {
    await this.getAvailableLanguages();
    await this.getTemplates()
  },

  methods: {
    async getTemplates() {
      const searchConstraints = {
        templates: true,
        websiteId: this.website.id
      }

      const searchResponse = await seoRulesService.search(this.currentLanguage.id, searchConstraints)

      this.seoTemplates = searchResponse.data;

      this.fetchedResults = true;
    },

    changeLanguageByCode(code) {
      this.changeLanguage(this.languages.find(language => language.code === code));
    },

    changeLanguage(language) {
      this.currentLanguage = language;
      this.getTemplates();
    },

    async getAvailableLanguages() {
      const allLanguagesResponse = await languageService.getAllOnlineLanguages();
      const allOnlineLanguages = allLanguagesResponse.data.items;

      const additionalLanguages = jsonParse(get(this, 'website.betshop.market.additionalLanguages')) || [];
      const defaultLanguage = get(this, 'website.betshop.market.defaultLanguage', 'en');

      const betshopLanguageCodes = [...new Set([defaultLanguage, ...additionalLanguages])];

      this.languages = allOnlineLanguages.filter(onlineLanguage => betshopLanguageCodes.includes(onlineLanguage.code))
      this.currentLanguage = this.languages[0];
      this.defaultLanguageId = this.languages.find(language => language.code === 'en')?.id
    },

    editSeoRule(seoRule) {
      this.$modal.show(
          EditSeoRuleModal,
          {
            seoRule,
            website: this.website,
            language: this.currentLanguage,
            handleSuccessCallback: this.getTemplates
          },
          { height: 'auto', scrollable: true, width: '80%' }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.c-search-filter-row {
  display: flex;

  .u-mr-md {
    margin-right: 16px !important;
  }
}

.c-search-additional-fields {
  display: flex;
  align-items: baseline;

  > div {
    margin-right: 10px;
  }
}
</style>
